import { render } from "./TeacherScreen8.vue?vue&type=template&id=ae61336c&scoped=true"
import script from "./TeacherScreen8.vue?vue&type=script&lang=js"
export * from "./TeacherScreen8.vue?vue&type=script&lang=js"

import "./TeacherScreen8.vue?vue&type=style&index=0&id=ae61336c&lang=css"
import "./TeacherScreen8.vue?vue&type=style&index=1&id=ae61336c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae61336c"]])

export default __exports__